// import React, { useEffect, useRef, useState } from "react";
// import mapboxgl from "mapbox-gl";
// import "mapbox-gl/dist/mapbox-gl.css";

// mapboxgl.accessToken =
//   "pk.eyJ1IjoiY2hlbm5haS0zNCIsImEiOiJjbTJhOWdya2owOXI4MnFyNDJxbGd2dDA2In0.tbGt2KA4L8a0bKTR3Uqc0A";

// const Map = ({ onSelect }) => {
//   const mapContainer = useRef(null);
//   const [map, setMap] = useState(null);
//   const [marker, setMarker] = useState(null);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [selectedLocation, setSelectedLocation] = useState(null);

//   useEffect(() => {
//     const mapInstance = new mapboxgl.Map({
//       container: mapContainer.current,
//       style: "mapbox://styles/mapbox/streets-v11",
//       center: [80.2705, 13.0843], // Center on Chennai, India
//       zoom: 5,
//     });

//     mapInstance.on("load", () => {
//       console.log("Map loaded successfully!");
//     });

//     setMap(mapInstance);

//     return () => mapInstance.remove();
//   }, []);

//   useEffect(() => {
//     if (map && selectedLocation) {
//       // Clear previous marker if any
//       if (marker) {
//         marker.remove();
//       }
//       // Create a new marker for the selected location
//       const newMarker = new mapboxgl.Marker()
//         .setLngLat(selectedLocation)
//         .addTo(map);
//       setMarker(newMarker);
//       map.flyTo({ center: selectedLocation, zoom: 10 });
//     }
//   }, [map, selectedLocation]);

//   const handleSearch = () => {
//     fetch(
//       `http://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(
//         searchQuery
//       )}.json?access_token=${mapboxgl.accessToken}`
//     )
//       .then((response) => response.json())
//       .then((data) => {
//         if (data.features.length > 0) {
//           const location = data.features[0];
//           const { center } = location;
//           const [lng, lat] = center;

//           setSelectedLocation({ lng, lat });
//         } else {
//           console.error("No results found for the search.");
//         }
//       })
//       .catch((err) => console.error("Error fetching location:", err));
//   };

//   const handleConfirm = () => {
//     if (selectedLocation) {
//       onSelect({
//         latitude: selectedLocation.lat,
//         longitude: selectedLocation.lng,
//       }); // Pass selected location to parent
//       alert(
//         `Location confirmed: ${selectedLocation.lat}, ${selectedLocation.lng}`
//       );
//     }
//   };

//   return (
//     <div>
//       <input
//         type="text"
//         placeholder="Search for a location"
//         value={searchQuery}
//         onChange={(e) => setSearchQuery(e.target.value)}
//         onKeyPress={(e) => e.key === "Enter" && handleSearch()} // Search on Enter key
//       />
//       <button onClick={handleSearch}>Search</button>
//       <button onClick={handleConfirm} disabled={!selectedLocation}>
//         Confirm Location
//       </button>
//       <div ref={mapContainer} style={{ width: "100%", height: "400px" }} />
//     </div>
//   );
// };

// export default Map;

// import React, { useEffect, useRef, useState } from "react";
// import mapboxgl from "mapbox-gl";
// import "mapbox-gl/dist/mapbox-gl.css";

// mapboxgl.accessToken =
//   "pk.eyJ1IjoiY2hlbm5haS0zNCIsImEiOiJjbTJhOWdya2owOXI4MnFyNDJxbGd2dDA2In0.tbGt2KA4L8a0bKTR3Uqc0A";

// const Map = ({ onSelect }) => {
//   const mapContainer = useRef(null);
//   const [map, setMap] = useState(null);
//   const [marker, setMarker] = useState(null);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [selectedLocation, setSelectedLocation] = useState(null);

//   useEffect(() => {
//     const mapInstance = new mapboxgl.Map({
//       container: mapContainer.current,
//       style: "mapbox://styles/mapbox/streets-v11",
//       center: [80.2705, 13.0843], // Center on Chennai, India
//       zoom: 5,
//     });

//     mapInstance.on("load", () => {
//       console.log("Map loaded successfully!");
//     });

//     setMap(mapInstance);

//     return () => mapInstance.remove();
//   }, []);

//   useEffect(() => {
//     if (map && selectedLocation) {
//       // Clear previous marker if any
//       if (marker) {
//         marker.remove();
//       }
//       // Create a new marker for the selected location
//       const newMarker = new mapboxgl.Marker()
//         .setLngLat([selectedLocation.lng, selectedLocation.lat])
//         .addTo(map);
//       setMarker(newMarker);
//       map.flyTo({
//         center: [selectedLocation.lng, selectedLocation.lat],
//         zoom: 10,
//       });
//     }
//   }, [map, selectedLocation]);

//   const handleSearch = () => {
//     fetch(
//       `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(
//         searchQuery
//       )}.json?access_token=${mapboxgl.accessToken}`
//     )
//       .then((response) => response.json())
//       .then((data) => {
//         if (data.features.length > 0) {
//           const location = data.features[0];
//           const [lng, lat] = location.center;

//           setSelectedLocation({ lng, lat });
//         } else {
//           console.error("No results found for the search.");
//         }
//       })
//       .catch((err) => console.error("Error fetching location:", err));
//   };

//   const handleConfirm = () => {
//     if (selectedLocation) {
//       onSelect({
//         latitude: selectedLocation.lat,
//         longitude: selectedLocation.lng,
//       }); // Pass selected location to parent
//       alert(
//         `Location confirmed: ${selectedLocation.lat}, ${selectedLocation.lng}`
//       );
//     }
//   };

//   return (
//     <div>
//       <input
//         type="text"
//         placeholder="Search for a location"
//         value={searchQuery}
//         onChange={(e) => setSearchQuery(e.target.value)}
//         onKeyPress={(e) => e.key === "Enter" && handleSearch()} // Search on Enter key
//       />
//       <button onClick={handleSearch}>Search</button>
//       <button onClick={handleConfirm} disabled={!selectedLocation}>
//         Confirm Location
//       </button>
//       <div ref={mapContainer} style={{ width: "100%", height: "400px" }} />
//     </div>
//   );
// };

// export default Map;

import React, { useEffect, useRef, useState } from "react";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";

mapboxgl.accessToken =
  "pk.eyJ1IjoiY2hlbm5haS0zNCIsImEiOiJjbTJhOWdya2owOXI4MnFyNDJxbGd2dDA2In0.tbGt2KA4L8a0bKTR3Uqc0A";

const Map = ({ onSelect }) => {
  const mapContainer = useRef(null);
  const [map, setMap] = useState(null);
  const [marker, setMarker] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [selectedAddress, setSelectedAddress] = useState("");

  useEffect(() => {
    const mapInstance = new mapboxgl.Map({
      container: mapContainer.current,
      style: "mapbox://styles/mapbox/streets-v11",
      center: [80.2705, 13.0843], // Center on Chennai, India
      zoom: 5,
    });

    mapInstance.on("load", () => {
      console.log("Map loaded successfully!");
    });

    setMap(mapInstance);

    return () => mapInstance.remove();
  }, []);

  useEffect(() => {
    if (map && selectedLocation) {
      if (marker) {
        marker.remove();
      }
      const newMarker = new mapboxgl.Marker()
        .setLngLat([selectedLocation.lng, selectedLocation.lat])
        .addTo(map);
      setMarker(newMarker);
      map.flyTo({
        center: [selectedLocation.lng, selectedLocation.lat],
        zoom: 10,
      });
    }
  }, [map, selectedLocation]);

  const handleSearch = () => {
    fetch(
      `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(
        searchQuery
      )}.json?access_token=${mapboxgl.accessToken}`
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.features.length > 0) {
          const location = data.features[0];
          const [lng, lat] = location.center;
          const address = location.place_name;

          setSelectedLocation({ lng, lat });
          setSelectedAddress(address); // Set address from geocoding result
        } else {
          console.error("No results found for the search.");
        }
      })
      .catch((err) => console.error("Error fetching location:", err));
  };

  const handleConfirm = () => {
    if (selectedLocation) {
      onSelect({
        lat: selectedLocation.lat,
        lng: selectedLocation.lng,
        address: selectedAddress, // Pass address to parent
      });
      alert(
        `Location confirmed: ${selectedAddress} (Lat: ${selectedLocation.lat}, Lng: ${selectedLocation.lng})`
      );
    }
  };

  return (
    <div>
      <input
        type="text"
        placeholder="Search for a location"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        onKeyPress={(e) => e.key === "Enter" && handleSearch()}
      />
      <button onClick={handleSearch}>Search</button>
      <button onClick={handleConfirm} disabled={!selectedLocation}>
        Confirm Location
      </button>
      <div ref={mapContainer} style={{ width: "100%", height: "400px" }} />
    </div>
  );
};

export default Map;
